export default __webpack_public_path__ + "static/media/defi-saver.74e01886.jpg";